import { windowScrollEvents, windowResizeEvents } from "../events";
import { createComponent, getUrlParameter, debounce } from "../utils";
import { DEFAULT_TIME_SHORT, DEFAULT_EASE, ani } from "../animations/config";
import gsap from "gsap";
import ScrollToPlugin from "gsap/ScrollToPlugin";

gsap.registerPlugin(ScrollToPlugin);

class SecondaryNav {
	constructor(el) {
		this.el = el;
		this.stickyMenuEl = el.querySelector(".submenu-wrapper");
		this.expanded = false;

		if (this.ignoreMenu(true)) {
			return;
		}

		// Bind expansion and also try to expand immediately
		this.setupEvents();
		this.handleParentZIndex();
		this.handleSideOpacity();
		this.expand();
	}

	ignoreMenu() {
		const removeMenu = getUrlParameter("removeMenu");
		if (removeMenu) return true;
	}

	setupEvents() {
		windowScrollEvents.push(this.expand.bind(this));
		windowResizeEvents.push(this.expand.bind(this));
		this.el
			.querySelector("ul")
			.addEventListener(
				"scroll",
				debounce(this.handleSideOpacity.bind(this), 30),
			);
		[...this.el.querySelectorAll("a")].map(a => {
			const href = a.getAttribute("href");
			if (!(href.indexOf("#") === 0)) return;
			a.addEventListener("click", e => {
				e.preventDefault();
				const section = document.querySelector(href);
				if (!section) return false;
				let scrollPos =
					window.pageYOffset + section.getBoundingClientRect().top;
				console.log("scrollPos", scrollPos);
				const marginTop = parseInt(
					window.getComputedStyle(section).marginTop,
					10,
				);

				const drupalPadding = parseInt(
					window.getComputedStyle(document.body).paddingTop,
					10,
				);
				scrollPos +=
					-1 * (this.el.offsetHeight + marginTop + drupalPadding + 20);
				console.log(42, scrollPos);
				gsap.to(
					window,
					DEFAULT_TIME_SHORT,
					ani(
						{
							scrollTo: { y: scrollPos },
						},
						DEFAULT_EASE,
					),
				);
			});
		});
	}

	handleParentZIndex() {
		this.el.closest(".section").style.zIndex = 2;
	}

	handleSideOpacity() {
		const scrolly = this.el.querySelector("ul");
		const area = this.el.querySelector(".submenu-area");
		const { scrollLeft, scrollWidth, offsetWidth } = scrolly;
		const canScroll = scrollWidth !== offsetWidth;
		const LEFT_SIDE = "left-side";
		const RIGHT_SIDE = "right-side";

		const add = [];
		const remove = [];

		scrollLeft !== 0 && canScroll
			? add.push(LEFT_SIDE)
			: remove.push(LEFT_SIDE);
		scrollLeft + offsetWidth !== scrollWidth && canScroll
			? add.push(RIGHT_SIDE)
			: remove.push(RIGHT_SIDE);

		remove.forEach(c => area.classList.remove(c));
		add.forEach(c => area.classList.add(c));
	}

	expand(e) {
		const top = this.el.getBoundingClientRect().top;
		this.handleSideOpacity();
		if (!this.expanded && top <= 0) {
			this.toggle(true);
		} else if (this.expanded && top > 0) {
			this.toggle(false);
		}
	}

	toggle(status) {
		const fn = status ? "add" : "remove";
		this.expanded = status;
		this.stickyMenuEl.classList[fn]("stuck");
	}

	animate() {}
}

export default SecondaryNav;
export const instantiatedSecondaryNavs = createComponent(
	".submenu",
	SecondaryNav,
);
